/**
 * assets/global.js
 * Winschoon Premium - vanilla JS only, no external dependencies.
 * Handles: mobile nav, search drawer, cart drawer + Ajax cart, quantity
 * steppers, product variant picker, product gallery, video modal and the
 * announcement bar rotation. Every module guards for missing elements so
 * this single file is safe to include on every template.
 */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------------- Helpers ---------------- */
  function qs(selector, ctx) { return (ctx || document).querySelector(selector); }
  function qsa(selector, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(selector)); }

  function trapFocus(container) {
    if (!container) return;
    var focusable = qsa('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (focusable.length) focusable[0].focus();
  }

  /* ---------------- Mobile nav ---------------- */
  var navToggle = qs('[data-nav-toggle]');
  var mobileNav = qs('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var isOpen = !mobileNav.hidden;
      mobileNav.hidden = isOpen;
      navToggle.setAttribute('aria-expanded', String(!isOpen));
      document.body.style.overflow = isOpen ? '' : 'hidden';
      if (!isOpen) trapFocus(mobileNav);
    });
  }

  /* ---------------- Search drawer ---------------- */
  qsa('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = qs('[data-search-drawer]');
      if (!drawer) return;
      var isOpen = !drawer.hidden;
      drawer.hidden = isOpen;
      if (!isOpen) {
        var input = qs('.search-drawer__input', drawer);
        if (input) input.focus();
      }
    });
  });

  /* ---------------- Announcement bar autorotate ---------------- */
  var bar = qs('[data-autorotate]');
  if (bar) {
    var items = qsa('.announcement-bar__item', bar);
    var interval = (parseInt(bar.getAttribute('data-interval'), 10) || 5) * 1000;
    var current = 0;
    if (items.length > 1) {
      setInterval(function () {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, interval);
    }
  }

  /* ---------------- Cart drawer + Ajax cart ---------------- */
  var cartDrawer = qs('[data-cart-drawer]');
  var cartType = document.body.getAttribute('data-cart-type');

  function toggleCartDrawer(forceOpen) {
    if (!cartDrawer) return;
    var isOpen = !cartDrawer.hidden;
    var shouldOpen = typeof forceOpen === 'boolean' ? forceOpen : isOpen;
    cartDrawer.hidden = shouldOpen ? false : true;
    document.body.style.overflow = shouldOpen ? 'hidden' : '';
  }

  qsa('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (cartType !== 'drawer') return; // let the link go to /cart
      e.preventDefault();
      toggleCartDrawer(cartDrawer.hidden);
    });
  });

  function updateCartCount(count) {
    var bubble = qs('[data-cart-count]');
    if (!bubble) return;
    bubble.textContent = count;
    bubble.hidden = count === 0;
  }

  function refreshFreeShippingBar() {
    var el = qs('[data-free-shipping-bar]');
    if (!el) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 5000;
        var fill = qs('.shipping-bar__fill', el);
        var message = qs('.shipping-bar__message', el);
        var remaining = threshold - cart.total_price;
        var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
        if (fill) fill.style.width = pct + '%';
        if (message) {
          message.textContent = remaining > 0
            ? (window.Winschoon && window.Winschoon.strings && window.Winschoon.strings.freeShippingRemaining
                ? window.Winschoon.strings.freeShippingRemaining.replace('{{amount}}', formatMoney(remaining))
                : 'Nog ' + formatMoney(remaining) + ' tot gratis verzending')
            : (window.Winschoon && window.Winschoon.strings && window.Winschoon.strings.freeShippingUnlocked
                ? window.Winschoon.strings.freeShippingUnlocked
                : 'Je hebt gratis verzending!');
        }
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function renderCartItemsFromSections() {
    // Simplest robust approach: reload the cart drawer markup section via Section Rendering API.
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshPanel = doc.querySelector('.cart-drawer__panel');
        var currentPanel = qs('.cart-drawer__panel');
        if (freshPanel && currentPanel) {
          currentPanel.innerHTML = freshPanel.innerHTML;
          refreshFreeShippingBar();
        }
      })
      .catch(function () {});
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(formData)
    }).then(function (r) { return r.json(); });
  }

  qsa('.product-form, .quick-add-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (cartType !== 'drawer') return; // normal form submit to /cart/add
      e.preventDefault();
      var submitBtn = qs('[data-add-to-cart]', form) || qs('button[type=submit]', form);
      var idInput = qs('input[name=id]', form);
      var qtyInput = qs('input[name=quantity]', form);
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
      addToCart({
        id: idInput ? idInput.value : undefined,
        quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
      })
        .then(function () {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            updateCartCount(cart.item_count);
          });
          renderCartItemsFromSections();
          toggleCartDrawer(true);
        })
        .finally(function () {
          if (submitBtn) submitBtn.removeAttribute('disabled');
        });
    });
  });

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    var item = removeBtn.closest('[data-cart-item]');
    if (!item) return;
    var key = item.getAttribute('data-key');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () {
      renderCartItemsFromSections();
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { updateCartCount(cart.item_count); });
    });
  });

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var decrease = e.target.closest('[data-quantity-decrease]');
    var increase = e.target.closest('[data-quantity-increase]');
    if (!decrease && !increase) return;
    var wrapper = (decrease || increase).closest('.quantity-input');
    var input = qs('.quantity-input__field', wrapper);
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    value = increase ? value + 1 : Math.max(1, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.quantity-input__field')) return;
    var cartItem = e.target.closest('[data-cart-item]');
    if (!cartItem) return; // only cart-drawer/cart-page inputs auto-update; product page qty is used on submit
    var key = cartItem.getAttribute('data-key');
    var quantity = parseInt(e.target.value, 10) || 1;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () {
      renderCartItemsFromSections();
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { updateCartCount(cart.item_count); });
    });
  });

  refreshFreeShippingBar();

  /* ---------------- Product variant picker ---------------- */
  qsa('.product-form').forEach(function (form) {
    var section = form.closest('section');
    if (!section) return;
    var dataEl = qs('[data-product-json]', section);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var selected = {};
    qsa('.product-form__pills', form).forEach(function (group) {
      var activePill = qs('.product-form__pill.is-selected', group);
      selected[group.getAttribute('data-option-index')] = activePill ? activePill.getAttribute('data-option-value') : null;
    });

    function findMatch() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return Object.keys(selected).every(function (idx) {
          return selected[idx] === null || opts[idx] === selected[idx];
        });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      var idInput = qs('[data-variant-id-input]', form);
      if (idInput) idInput.value = variant.id;
      var submit = qs('[data-add-to-cart]', form);
      var submitText = qs('[data-add-to-cart-text]', form);
      var priceWrapper = qs('[data-price-wrapper]', section);
      if (submit) submit.toggleAttribute('disabled', !variant.available);
      if (submitText) {
        submitText.textContent = variant.available
          ? (window.Winschoon && window.Winschoon.strings && window.Winschoon.strings.addToCart || 'Toevoegen aan winkelwagen')
          : (window.Winschoon && window.Winschoon.strings && window.Winschoon.strings.soldOut || 'Uitverkocht');
      }
      if (priceWrapper && variant.price !== undefined) {
        var current = priceWrapper.querySelector('.price__regular, .price__sale');
        if (current) current.textContent = formatMoney(variant.price);
      }
    }

    qsa('.product-form__pills', form).forEach(function (group) {
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('.product-form__pill');
        if (!pill) return;
        qsa('.product-form__pill', group).forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        var label = group.closest('.product-form__option').querySelector('[data-selected-option-value]');
        if (label) label.textContent = pill.getAttribute('data-option-value');
        selected[group.getAttribute('data-option-index')] = pill.getAttribute('data-option-value');
        applyVariant(findMatch());
      });
    });
  });

  /* ---------------- Product gallery ---------------- */
  qsa('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = qs('[data-gallery-main]');
      var mediaTemplate = qs('[data-gallery-media-template]', thumb);
      if (!main) return;

      qsa('video, audio', main).forEach(function (media) { media.pause(); });

      if (mediaTemplate) {
        main.innerHTML = '';
        main.appendChild(mediaTemplate.content.cloneNode(true));
      } else {
        var mainImage = qs('#ProductMainImage');
        if (!mainImage) return;
        mainImage.src = thumb.getAttribute('data-full');
        mainImage.alt = thumb.getAttribute('data-alt') || '';
      }

      qsa('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------------- Video modal ---------------- */
  var videoModal = qs('[data-video-modal]');
  if (videoModal) {
    var mediaContainer = qs('[data-video-modal-media]', videoModal);
    var videoSource = qs('[data-video-modal-source]');

    qsa('[data-video-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        videoModal.hidden = false;
        document.body.style.overflow = 'hidden';
        if (mediaContainer && videoSource) {
          mediaContainer.innerHTML = '';
          mediaContainer.appendChild(videoSource.content.cloneNode(true));
        }
        trapFocus(videoModal);
      });
    });
    qsa('[data-video-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        videoModal.hidden = true;
        document.body.style.overflow = '';
        if (mediaContainer) mediaContainer.innerHTML = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !videoModal.hidden) {
        videoModal.hidden = true;
        document.body.style.overflow = '';
        if (mediaContainer) mediaContainer.innerHTML = '';
      }
    });
  }
})();
